import { render, staticRenderFns } from "./bigScreen.vue?vue&type=template&id=d9710aa2&"
import script from "./bigScreen.vue?vue&type=script&lang=js&"
export * from "./bigScreen.vue?vue&type=script&lang=js&"
import style0 from "./bigScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports